export const colors = {
    primary: '#5843E4',
    secondary: '#8186A0',
    backgroundLight: '#F9F9FC',
    dark: '#2e2e41',
    white: 'white',
    light: 'white'
}
